export default __webpack_public_path__ + "static/media/Image-13.ff4cd3de.jpg";